// src/components/Loader.jsx
export default function Loader() {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-cream/95 to-yellow-50 flex flex-col items-center justify-center z-50">
      {/* Spinner */}
      <div className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 border-4 sm:border-6 md:border-8 border-maroon border-t-transparent rounded-full animate-spin shadow-lg"></div>

      {/* Optional Loading Text */}
      <p className="mt-4 sm:mt-6 text-maroon text-sm sm:text-base md:text-lg font-semibold animate-pulse">
        Loading...
      </p>

      {/* Background animation (optional subtle glow) */}
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-yellow-100/10 blur-2xl"
      />
      
      {/* Custom animation styles */}
      <style jsx>{`
        @keyframes pulseText {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
        .animate-pulse {
          animation: pulseText 1.5s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}
